import { RadioFilterGroup, RadioFilterOption } from '@retail/components';
import { useCampaignTFunction } from '@retail/campaign/i18n';
import { CampaignDatePreset } from '@retail/campaign/types';
import { useMemo } from 'react';

interface Props {
  selectedPreset: CampaignDatePreset;
  selectPreset: (preset: CampaignDatePreset) => void;
}

export function CampaignDatePresetFilter({ selectedPreset, selectPreset }: Props) {
  const t = useCampaignTFunction();

  const options: RadioFilterOption<CampaignDatePreset>[] = useMemo(
    () => [
      {
        label: t('campaign.filters.datePresets.currentAndUpcoming.label'),
        value: 'CURRENT_AND_UPCOMING',
      },
      { label: t('campaign.filters.datePresets.past.label'), value: 'PAST' },
    ],
    [t]
  );

  return (
    <RadioFilterGroup
      label={t('campaign.filters.datePresets.label')}
      options={options}
      value={selectedPreset}
      onChange={selectPreset}
    />
  );
}
